const BASE = 'https://api.github.com';

function ghHeaders(pat) {
	return {
		Authorization: `Bearer ${pat}`,
		Accept: 'application/vnd.github+json',
		'Content-Type': 'application/json',
		'X-GitHub-Api-Version': '2022-11-28',
	};
}

function encodeUtf8Base64(str) {
	return btoa(
		new TextEncoder()
			.encode(str)
			.reduce((s, b) => s + String.fromCharCode(b), '')
	);
}

function decodeBase64Utf8(b64) {
	return new TextDecoder().decode(
		Uint8Array.from(atob(b64.replace(/\n/g, '')), c => c.charCodeAt(0))
	);
}

async function ghFetch(pat, method, url, body = null) {
	const res = await fetch(url, {
		method,
		headers: ghHeaders(pat),
		body: body != null ? JSON.stringify(body) : undefined,
	});
	if (!res.ok) {
		const text = await res.text();
		throw new Error(`GitHub ${res.status}: ${text}`);
	}
	if (res.status === 204) return null;
	return res.json();
}

export async function getFile(pat, owner, repo, filePath, branch) {
	const data = await ghFetch(
		pat, 'GET',
		`${BASE}/repos/${owner}/${repo}/contents/${filePath}?ref=${branch}`
	);
	return { content: decodeBase64Utf8(data.content), sha: data.sha };
}

export async function putTextFile(pat, owner, repo, filePath, branch, content, sha, commitMsg) {
	const body = { message: commitMsg, content: encodeUtf8Base64(content), branch };
	if (sha) body.sha = sha; // omit entirely for new files — GitHub rejects sha:null on create
	return ghFetch(pat, 'PUT', `${BASE}/repos/${owner}/${repo}/contents/${filePath}`, body);
}

export async function listDirectory(pat, owner, repo, dirPath, branch) {
	return ghFetch(
		pat, 'GET',
		`${BASE}/repos/${owner}/${repo}/contents/${dirPath}?ref=${branch}`
	);
}

export async function uploadBinary(pat, owner, repo, filePath, branch, arrayBuffer, existingSha, commitMsg) {
	const bytes = new Uint8Array(arrayBuffer);
	let binary = '';
	bytes.forEach(b => (binary += String.fromCharCode(b)));
	const body = { message: commitMsg, content: btoa(binary), branch };
	if (existingSha) body.sha = existingSha;
	return ghFetch(pat, 'PUT', `${BASE}/repos/${owner}/${repo}/contents/${filePath}`, body);
}

export async function deleteFile(pat, owner, repo, filePath, branch, sha, commitMsg) {
	return ghFetch(pat, 'DELETE', `${BASE}/repos/${owner}/${repo}/contents/${filePath}`, {
		message: commitMsg,
		sha,
		branch,
	});
}

// Returns the raw public URL for an asset — no auth needed for public repos.
export function rawContentUrl(owner, repo, branch, filePath) {
	return `https://raw.githubusercontent.com/${owner}/${repo}/${branch}/${filePath}`;
}
